module.exports = __webpack_public_path__ + "img/HP-bg-image-min.aa81dd5e.jpg";